import { render, staticRenderFns } from "./FeedbackManager.vue?vue&type=template&id=2ac4b264&"
import script from "./FeedbackManager.vue?vue&type=script&lang=js&"
export * from "./FeedbackManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports